/** declare only http service related requests */

import { HttpTokens, GetLorHistory, LorHistoryQuery } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get /legal/lor/history/{id}?
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const LegalLorHistoryGet = (
  prefix: string = 'legal/lor/history',
  id: string,
  params: LorHistoryQuery,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetLorHistory> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const queryUri = paramsQueryString(`${prefix}/${id}`, params);
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetLorHistory>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetLorHistory>;
};
